import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const createProfileSave = React.createContext({});
export let createProfileSaveMachine: any;

const MODULE_NAME = 'machines.createProfileSave';

export const useSMCreateProfileSave = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  createProfileSaveMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(createProfileSaveMachine);

  return {
    createProfileSaveMachine,
    createProfileSaveState: state,
    createProfileSaveSend: send,
  };
};
